import {initWebComponent} from "@/helpers/web-component-helper";
import {enableCesium} from "@/helpers/cesium/cesium-helper";
import {activateLayer} from "@/helpers/ol/ol-layer-helper";
import {zoomToLayer} from "@/helpers/ol/ol-zoom-helper";
import {getService3DTileSetByID} from "@/modules/cesium/cesium-service";

const template = document.createElement('template');



export class LayerMenuButton3dComponent extends HTMLElement{
    constructor(){
        super();

        const label = this.closest('layer-menu-group-item').dataset.label

        const id = this.getAttribute('data-id')

        template.innerHTML = `<button title="Open 3D voor: ${label}" class="btn btn-sm borderless icon-btn text-transform-none">
              <span class="fa fa-cube"></span>
            </button>`

        initWebComponent(this, template)
        let interval

        this.addEventListener('click', () => {
            enableCesium()
            activateLayer(id)
            let zoomed

            this.querySelector('button').classList.toggle('active')

            zoomed = zoomToLayer(id)

            if(!zoomed) {
                interval = setInterval(() => {
                    // console.log('check zoom')
                    zoomed = getService3DTileSetByID(id)
                    if (zoomed) {
                        zoomToLayer(id)
                        clearInterval(interval)
                    }
                }, 1000)
            }

        })
    }
}
